// @ts-check
import { getAll, get } from "@/utilities/querySelector";
import { toggleScroll } from "@/utilities/toggleScroll";
import { initialiseSlider, unslickSlider } from "@/template-parts/slider";

initDialogListeners();

function initDialogListeners() {
    const triggers = getAll( '[data-dialog]' );
    const closers = getAll( '[data-dialog-close]' );
    const dialogs = getAll( 'dialog.dialog' );

    triggers.forEach( trigger => {
        trigger.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            const dialogName = trigger.getAttribute( 'data-dialog' );
            const dialog = get( `dialog#${dialogName}` );
            const asModal = trigger.getAttribute( 'data-is-modal' ) ?? 'true';

            if ( !dialog ) {
                console.warn( 'No dialog with ID: ' + dialogName );
                return;
            }

            openDialog( dialog, asModal === 'true' );
        } );
    } );

    closers.forEach( closer => {
        closer.addEventListener( 'click', ( e ) => {
            const dialog = closer.closest( 'dialog' );
            if ( !dialog ) return;
            closeDialog( dialog );
        } );
    } );

    dialogs.forEach( dialog => dialog.addEventListener( 'close', () => toggleScroll( true ) ) );
}

/**
 *
 * @param {HTMLDialogElement} dialog
 */
function openDialog( dialog, asModal = true ) {
    asModal ? dialog.showModal() : dialog.show();
    dialog.classList.add( 'dialog-is-open' );
    if ( asModal ) toggleScroll( false );

    const modalSlider = get('[data-card-slider]', dialog);
    if (modalSlider) {
        jQuery(function($) {
            initialiseSlider(modalSlider, $);
        });
    }
}

/**
 *
 * @param {HTMLDialogElement} dialog
 */
function closeDialog( dialog ) {
    const closeHandler = ( e ) => {
        if ( e.target !== dialog ) return;
        dialog.close();
        dialog.removeEventListener( 'transitionend', closeHandler );
    };
    dialog.addEventListener( 'transitionend', closeHandler );
    dialog.classList.remove( 'dialog-is-open' );

    // const modalSlider = get('[data-card-slider]', dialog);
    // if (modalSlider) {
    //     jQuery(function($) {
    //         setTimeout(() => unslickSlider(modalSlider, $), 500);
    //     });
    // }
}

const dialogs = getAll('dialog');
if (dialogs) {
    dialogs.forEach(dialog => {
        const buttons = getAll('[data-anchor-link]', dialog);

        buttons.forEach(button => {
            button.addEventListener('click', (e) => {
                closeDialog(dialog);
            });
        });
    });
}
